<div class="item" [formGroup]="form">
  <h2>Produto #{{ index }}</h2>
  <app-fields>
    <app-input formControlName="codigo" label="Código SKU"></app-input>
    <app-input formControlName="codigoBarras" label="GTIN/EAN"></app-input>
    <app-select
      formControlName="ncm"
      [options]="ncms()"
      label="NCM"
      (outputChange)="handleNcmChange($event.value)"
    >
    </app-select>
    <app-select
      label="CFOP"
      [options]="cfopList"
      [virtualScroll]="true"
      [filter]="true"
      formControlName="cfop"
    ></app-select>
  </app-fields>
  <app-fields>
    <app-input
      type="textarea"
      formControlName="descricao"
      label="Descrição"
    ></app-input>
  </app-fields>
  <app-fields>
    <ng-container formGroupName="valorUnitario">
      <app-input
        formControlName="comercial"
        label="Valor unitário comercial"
        type="currency"
      ></app-input>
      <app-input
        formControlName="tributavel"
        label="Valor unitário tributável"
        type="currency"
      ></app-input>
    </ng-container>
    <ng-container formGroupName="quantidade">
      <app-input
        formControlName="comercial"
        label="Quantidade comercial"
        type="number"
      ></app-input>
      <app-input
        formControlName="tributavel"
        label="Quantidade tributável"
        type="number"
      ></app-input>
    </ng-container>
    <ng-container formGroupName="unidade">
      <app-select
        formControlName="comercial"
        label="Unidade comercial"
        [options]="unitOptions"
      ></app-select>
      <app-select
        formControlName="tributavel"
        label="Unidade tributável"
        type="number"
        [options]="unitOptions"
      ></app-select>
    </ng-container>
    <app-input
      label="Valor do frete"
      formControlName="valorFrete"
      type="currency"
    ></app-input>
    <app-input
      label="Valor do seguro"
      formControlName="valorSeguro"
      type="currency"
    ></app-input>
    <ng-container *ngIf="company?.()?.regimeTributario === '3' || company?.()?.regimeTributario === '4'">
      <app-input
        label="Valor da BC (ICMS)"
        formControlName="valorBaseCalculoIcms"
        type="currency"
        [title]="'Este valor é por produto e será incluído na NF-e para LP/LR'"
      ></app-input>
    </ng-container>
  </app-fields>
</div>
